import React from 'react';
import { useMapCanvasStage, useMapCanvasShapes } from '../../contexts/MapCanvasContext';
import { useMapEditorActions, useMapEditorSelection, useMapEditorTool } from '../../contexts/MapEditorContext';
import { MultiSelectionToolbox } from './ShapeToolbox/MultiSelectionToolbox';
import { ShapeToolbox } from './ShapeToolbox/ShapeToolbox';
import { ToolsPickerToolbar } from './ToolsPickerToolbar';
import { ResourceToolBox } from './ShapeToolbox/ResourceToolBox';

export const EditorToolbars: React.FC = () => {
  const { selectedIds } = useMapEditorSelection();
  const { activeTool } = useMapEditorTool();
  const {
    updateShape,
    deleteShape,
    moveShape,
    setActiveTool,
    locateShape
  } = useMapEditorActions();

  const { stageScale } = useMapCanvasStage();
  const { shapes } = useMapCanvasShapes();

  const selectedShape = React.useMemo(
    () =>
      selectedIds.length === 1
        ? shapes.find((s) => s.id === selectedIds[0])
        : undefined,
    [shapes, selectedIds]
  );

  const selectedSpots = React.useMemo(
    () =>
      selectedIds.length > 0
        ? shapes.filter(
            (s) => s.type === 'spot' && selectedIds.includes(s.id)
          )
        : [],
    [shapes, selectedIds]
  );

  return (
    <>
      <div className="relative z-10">
        <ToolsPickerToolbar
          activeTool={activeTool}
          onToolChange={setActiveTool}
        />
        {selectedIds.length === 1 && selectedShape && (
          <ShapeToolbox
            shape={selectedShape}
            stageScale={stageScale}
            onUpdate={updateShape}
            onDelete={() => deleteShape(selectedIds[0])}
            onLocate={() => locateShape(selectedIds[0])}
            onMoveUp={() => moveShape(selectedIds[0], 'up')}
            onMoveDown={() => moveShape(selectedIds[0], 'down')}
          />
        )}
        {selectedIds.length > 1 && (
          <MultiSelectionToolbox selectedIds={selectedIds} />
        )}
        {selectedSpots.length > 0 && (
          <ResourceToolBox shapes={selectedSpots} />
        )}
      </div>
    </>
  );
};
